module.exports = __webpack_public_path__ + "static/media/perfil.77a600a7.svg";